import R from 'ramda';
import { combineReducers } from 'redux';

import { STATE_NAME } from '../constants';
import features, { getFeatures } from './features';
import status, { isLoading, isLoaded } from './status';

export default combineReducers({ features, status });

export const getState = R.prop(STATE_NAME);

export const getFeatureFlags = R.compose(
  getFeatures,
  getState,
);

export const isLoadingFeatureFlags = R.compose(
  isLoading,
  getState,
);

export const isLoadedFeatureFlags = R.compose(
  isLoaded,
  getState,
);
